import { render, staticRenderFns } from "./package_list.vue?vue&type=template&id=28e7ac13"
import script from "./package_list.vue?vue&type=script&lang=js"
export * from "./package_list.vue?vue&type=script&lang=js"
import style0 from "./package_list.vue?vue&type=style&index=0&id=28e7ac13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports